import { useEffect } from "react";
import { useQuery } from "~/hooks/useQuery";

export const useReferralToken = (): string | null => {
  const query = useQuery();
  const referralToken = query.get("referral_token");

  // This ensures that the referral_token is stored, in case the Visitor
  // visits another page before signing up.
  useEffect(() => {
    if (referralToken) {
      localStorage.setItem("referral_token", referralToken);
    }
  }, [referralToken]);

  const value = referralToken || localStorage.getItem("referral_token");

  return value;
};
